package com.hyperether.goodjob.util

import kotlinx.browser.window

actual fun decodeBase64(base64: String): String? {
   return window.atob(base64)
}